import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row items-center q-pb-md" }
const _hoisted_2 = { class: "col-2 text-subtitle1 text-fun-label-and-icon" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col q-pr-md" }
const _hoisted_5 = { class: "col q-pl-md" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col q-pr-md" }
const _hoisted_8 = { class: "col q-pl-md" }
const _hoisted_9 = { class: "row justify-between" }
const _hoisted_10 = { class: "row text-body1" }
const _hoisted_11 = { class: "col q-pr-md" }
const _hoisted_12 = { class: "row items-center q-pb-sm" }
const _hoisted_13 = { class: "row items-center q-pb-sm" }
const _hoisted_14 = { class: "row items-center q-pb-sm" }
const _hoisted_15 = { class: "col q-pl-md" }
const _hoisted_16 = { class: "row items-center q-pb-sm" }
const _hoisted_17 = { class: "row items-center q-pb-sm" }

import { is, useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxSeparator from "src/components/special/SfxSeparator.vue"
import SfxToggleSettings from "src/components/toggle/SfxToggleSettings.vue"
import SfxSelect from "src/components/select/SfxSelect.vue"
import SfxPriorityFilter from "src/components/priority-filter/SfxPriorityFilter.vue"
import SfxFilterRegularWorkRaisedFrom from "src/components/filter/SfxFilterRegularWorkRaisedFrom.vue"
import SfxFilterItems from "src/components/filter/SfxFilterItems.vue"
import SfxBtnLink from "src/components/button/SfxBtnLink.vue"
import router from "src/router"
import { IssuesPageFilters, useFilterStore } from "src/stores/filterStore"
import {
  ISSUE_FILTER_STATE,
  ITEM_FILTERS_DEFAULT,
  REGULAR_WORK_RAISED_FROM_FILTERS_DEFAULT,
} from "src/util/constants/filters"
import {
  ENTITY_TYPE,
  INCLUDE_REJECTED,
  INCLUDE_SUPERSEDED,
  RAISED_THROUGH,
} from "src/util/enums/filters"
import { NamedManagerPath } from "src/util/enums/namedPaths"
import { getItemClassListData, getWorkDomainWorkspaceListData } from "src/util/functions/entityData"
import { ItemClass } from "src/util/types/dataModels/itemClass"
import { WorkDomainWorkspace } from "src/util/types/dataModels/workDomain"
import SfxFilterSystemLink from "src/components/filter/SfxFilterSystemLink.vue"
import { onBeforeMount, reactive, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogFilterIssues',
  props: {
  entityForWorkOrderPage: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()
const filterStore = useFilterStore()
const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const workDomainOptions = ref<WorkDomainWorkspace[]>([])
const itemClassOptions = ref<ItemClass[]>([])

const issuePageFilters = reactive<IssuesPageFilters>({ ...filterStore.issuesPageFilters })

//endregion

//region Lifecycle

onBeforeMount(async () => {
  const workDomains = await getWorkDomainWorkspaceListData()
  workDomainOptions.value = workDomains.map((workDomain) => workDomain.toMutableJSON())
  const itemClasses = await getItemClassListData()
  itemClassOptions.value = itemClasses.map((itemClass) => itemClass.toMutableJSON())
})

//endregion

//region Functions

function handleSystemLinkClose() {
  issuePageFilters.systemLink = undefined
  filterStore.issuesPageFilters.systemLink = undefined
}

function saveFilters() {
  filterStore.issuesPageFilters = issuePageFilters

  // Set the flag values
  filterStore.issuesPageFilters.hasFilters = true
  filterStore.issuesPageFilters.hasItemFilters = !is.deepEqual(
    issuePageFilters?.itemFilter,
    ITEM_FILTERS_DEFAULT
  )
  filterStore.issuesPageFilters.hasRegularWorkFilters = !is.deepEqual(
    issuePageFilters?.regularWorkFilter,
    REGULAR_WORK_RAISED_FROM_FILTERS_DEFAULT
  )

  onDialogOK()

  if (!props.entityForWorkOrderPage) {
    router.replace({
      name: NamedManagerPath.SELECT_ISSUE,
      query: {
        filters: JSON.stringify(filterStore.issuesPageFilters),
      },
    })
  }
}

function selectAll() {
  issuePageFilters.state = ISSUE_FILTER_STATE
}

function selectNone() {
  issuePageFilters.state = []
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "sfx-dialog-filter"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 q-pb-lg" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.title_filter_issues")), 1)
            ]),
            _: 1
          }),
          (issuePageFilters.systemLink)
            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(SfxFilterSystemLink, {
                    "system-link": issuePageFilters.systemLink,
                    onRemove: _cache[0] || (_cache[0] = ($event: any) => (handleSystemLinkClose()))
                  }, null, 8, ["system-link"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              (!props.entityForWorkOrderPage)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)("sfxDialogFilter.work_domain")), 1),
                      _createVNode(SfxSelect, {
                        class: "col-10",
                        placeholder: _unref(t)('sfxDialogFilter.place_holder_work_domain'),
                        modelValue: issuePageFilters.workDomain,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((issuePageFilters.workDomain) = $event)),
                        options: workDomainOptions.value,
                        "option-label": (opt) => opt.designation,
                        "option-value": (opt) => opt.id,
                        loading: workDomainOptions.value?.length === 0,
                        "emit-value": "",
                        "map-options": "",
                        "use-chips": "",
                        multiple: ""
                      }, null, 8, ["placeholder", "modelValue", "options", "option-label", "option-value", "loading"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(SfxToggleSettings, {
                          class: "q-py-none",
                          html: "",
                          trinary: "",
                          modelValue: issuePageFilters.entityType,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((issuePageFilters.entityType) = $event)),
                          description: _unref(t)('sfxDialogFilter.entity_type'),
                          "true-value": _unref(ENTITY_TYPE).ITEM,
                          "true-label": _unref(t)('sfxDialogFilter.item'),
                          "false-value": _unref(ENTITY_TYPE).AREA,
                          "false-label": _unref(t)('sfxDialogFilter.area'),
                          "indeterminate-value": _unref(ENTITY_TYPE).EITHER,
                          "indeterminate-label": _unref(t)('sfxDialogFilter.either'),
                          disable: ""
                        }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label", "indeterminate-value", "indeterminate-label"])
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(SfxToggleSettings, {
                          class: "q-py-none",
                          html: "",
                          trinary: "",
                          modelValue: issuePageFilters.raisedThrough,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((issuePageFilters.raisedThrough) = $event)),
                          description: _unref(t)('sfxDialogFilter.raised_through'),
                          "true-value": _unref(RAISED_THROUGH).YES,
                          "true-label": _unref(t)('sfxDialogFilter.yes'),
                          "false-value": _unref(RAISED_THROUGH).NO,
                          "false-label": _unref(t)('sfxDialogFilter.no'),
                          "indeterminate-value": _unref(RAISED_THROUGH).EITHER,
                          "indeterminate-label": _unref(t)('sfxDialogFilter.either')
                        }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label", "indeterminate-value", "indeterminate-label"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(SfxToggleSettings, {
                          class: "q-py-none",
                          html: "",
                          modelValue: issuePageFilters.includeSuperseded,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((issuePageFilters.includeSuperseded) = $event)),
                          description: _unref(t)('sfxDialogFilter.included_supersede'),
                          "true-value": _unref(INCLUDE_SUPERSEDED).YES,
                          "true-label": _unref(t)('sfxDialogFilter.yes'),
                          "false-value": _unref(INCLUDE_SUPERSEDED).NO,
                          "false-label": _unref(t)('sfxDialogFilter.no')
                        }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(SfxToggleSettings, {
                          class: "q-py-none",
                          html: "",
                          modelValue: issuePageFilters.includeRejected,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((issuePageFilters.includeRejected) = $event)),
                          description: _unref(t)('sfxDialogFilter.include_rejected'),
                          "true-value": _unref(INCLUDE_REJECTED).YES,
                          "true-label": _unref(t)('sfxDialogFilter.yes'),
                          "false-value": _unref(INCLUDE_REJECTED).NO,
                          "false-label": _unref(t)('sfxDialogFilter.no')
                        }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label"])
                      ])
                    ]),
                    _createVNode(SfxSeparator, { class: "sfx-separator-text" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.priorities")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(SfxPriorityFilter, {
                      modelValue: issuePageFilters.priority,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((issuePageFilters.priority) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(SfxSeparator, { class: "sfx-separator-text" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.states")), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(SfxBtnLink, {
                        class: "q-pl-none",
                        label: _unref(t)('sfxButtons.btn_select_none'),
                        onClick: selectNone
                      }, null, 8, ["label"]),
                      _createVNode(SfxBtnLink, {
                        class: "q-pr-none",
                        label: _unref(t)('sfxButtons.btn_select_all'),
                        onClick: selectAll
                      }, null, 8, ["label"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.raised")), 1),
                          _createVNode(_component_q_space),
                          _createVNode(_component_q_checkbox, {
                            modelValue: issuePageFilters.state,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((issuePageFilters.state) = $event)),
                            val: "raised",
                            size: "48px",
                            color: "secondary",
                            dense: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.corrected")), 1),
                          _createVNode(_component_q_space),
                          _createVNode(_component_q_checkbox, {
                            modelValue: issuePageFilters.state,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((issuePageFilters.state) = $event)),
                            val: "corrected",
                            size: "48px",
                            color: "secondary",
                            dense: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.corrected_closed")), 1),
                          _createVNode(_component_q_space),
                          _createVNode(_component_q_checkbox, {
                            modelValue: issuePageFilters.state,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((issuePageFilters.state) = $event)),
                            val: "corrected_closed",
                            size: "48px",
                            color: "secondary",
                            dense: ""
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.in_work_order")), 1),
                          _createVNode(_component_q_space),
                          _createVNode(_component_q_checkbox, {
                            modelValue: issuePageFilters.state,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((issuePageFilters.state) = $event)),
                            val: "in_work_order",
                            size: "48px",
                            color: "secondary",
                            dense: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.closed")), 1),
                          _createVNode(_component_q_space),
                          _createVNode(_component_q_checkbox, {
                            modelValue: issuePageFilters.state,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((issuePageFilters.state) = $event)),
                            val: "closed",
                            size: "48px",
                            color: "secondary",
                            dense: ""
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _createVNode(SfxSeparator, { class: "sfx-separator-text" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.related_entities")), 1)
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              (issuePageFilters.itemFilter)
                ? (_openBlock(), _createBlock(SfxFilterItems, {
                    key: 1,
                    "item-filters": issuePageFilters.itemFilter,
                    "onUpdate:itemFilters": _cache[12] || (_cache[12] = ($event: any) => ((issuePageFilters.itemFilter) = $event)),
                    "item-class-options": itemClassOptions.value,
                    "expand-section": !props.entityForWorkOrderPage
                  }, null, 8, ["item-filters", "item-class-options", "expand-section"]))
                : _createCommentVNode("", true),
              _createVNode(SfxSeparator, { dimmed: "" }),
              (issuePageFilters.regularWorkFilter)
                ? (_openBlock(), _createBlock(SfxFilterRegularWorkRaisedFrom, {
                    key: 2,
                    "regular-work-filters": issuePageFilters.regularWorkFilter,
                    "onUpdate:regularWorkFilters": _cache[13] || (_cache[13] = ($event: any) => ((issuePageFilters.regularWorkFilter) = $event)),
                    "expand-section": !props.entityForWorkOrderPage
                  }, null, 8, ["regular-work-filters", "expand-section"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "row justify-center q-pa-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                class: "col-4 q-mr-sm",
                onClick: _unref(onDialogCancel),
                label: _unref(t)('sfxButtons.btn_close')
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                class: "col-4",
                onClick: saveFilters,
                label: _unref(t)('sfxButtons.btn_apply_changes')
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})